import React          from 'react';
import Input          from './Input';
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles(() => ({
    root: {
        position:       'fixed',
        height:         80,
        width:          '100vw',
        display:        'flex',
        alignItems:     'center',
        justifyContent: 'center',
    }
}))

type InputContainerProps = {
    size:                number[];
    selectedInputBox:    number;
    target_size:         number;
    wideScreen:          boolean;
    stage1complete:      boolean;
    input1:              string;
    input2:              string;
    input3:              string;
    operator1:           string;
    operator2:           string;
    setSelectedInputBox: (val: number) => void;
    handleInputClick:    (val: number) => void;
}

const InputContainer: React.FC<InputContainerProps> = ({
    size,
    wideScreen,
    stage1complete,
    input1,
    input2,
    input3,
    operator1,
    operator2,
    selectedInputBox,
    target_size,
    setSelectedInputBox,
    handleInputClick
}) => {

  const classes = useStyles();

  const arr = React.useMemo(() => {

    const stage1 = [input1, operator1, input2];
    const stage2 = stage1.concat([operator2, input3]);

    return !stage1complete ? stage1 : stage2

  },[input1, input2, input3, operator1, operator2, stage1complete])

  return (

    <div 
       className = { classes.root }
       style     = {{
         top: (size[1]/2) - (target_size/2) - (size[0] > 1000 ? 10 : 40)
       }}
    >
      {
        arr.map((val ,ind) => {
            return(
              <Input
                 key                 = { `Input?!?*${ ind }` }
                 wideScreen          = { wideScreen }
                 ind                 = { ind }
                 string              = { val }
                 selectedInputBox    = { selectedInputBox }
                 setSelectedInputBox = { setSelectedInputBox }      
                 handleInputClick    = { handleInputClick }
              />
            )
        })
      }
    </div>
  );
}

export default InputContainer;
